import { render, staticRenderFns } from "./BaseTip.vue?vue&type=template&id=7f431d41&scoped=true&lang=pug"
import script from "./BaseTip.vue?vue&type=script&lang=ts"
export * from "./BaseTip.vue?vue&type=script&lang=ts"
import style0 from "./BaseTip.vue?vue&type=style&index=0&id=7f431d41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f431d41",
  null
  
)

export default component.exports